import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import classnames from "classnames";
import PropTypes from "prop-types";
import styles from "./HistoricalClientSearch.scss";

import get from "lodash/get";

import SearchEligibleClients from "../SearchEligibleClients";

function HistoricalClientSearch({ clinicId }) {
  const [selectedClientData, setSelectedClientData] = useState(null);
  const selectedClientId = get(selectedClientData, "clientId", null);
  let history = useHistory();

  useEffect(() => {
    if (!!clinicId && !!selectedClientId) {
      history.push(
        `/admin/clinic/${clinicId}/programs/eligibility-tracker/history/${selectedClientId}`
      );
    }
  }, [clinicId, selectedClientId]);

  return (
    <div className={classnames(styles.root, "flex flex-none margin-bottom-sm")}>
      <div className={styles.tile}>
        <div className={"flex align-center"}>
          <div className="flex-none margin-right-md">
            <h3>Eligibility History</h3>
            <div className={styles.copy}>
              Search by client name to view past eligibility details for each
              pet
            </div>
            <div className={styles.input}>
              <SearchEligibleClients
                clinicId={clinicId}
                onChange={(data, value) => setSelectedClientData(value)}
                name="client"
                value={selectedClientId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HistoricalClientSearch.propTypes = {
  clientId: PropTypes.number,
};

export default HistoricalClientSearch;
